import moment from "moment"

const now = moment().add(-1, 'day').endOf('day');

export function deleteTimeOutClipsFromPrograms(clips) {

    const result = clips.filter(clip => now.isBefore(moment(clip.todate)))
    return result;
}